export var source_content_template = { "uid": "source_content_template", "fields": { "title": { "defaultValue": "" } } };
